"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _useLazyRef = _interopRequireDefault(require("../hooks/useLazyRef"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var GojobLogo = function GojobLogo(props, ref) {
  var seedId = (0, _useLazyRef["default"])(function () {
    return Math.random();
  }).current;
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 128,
    height: 92,
    viewBox: "0 0 128 92"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("defs", null, (0, _core.jsx)("path", {
    d: "M42.723 82.666c-3.065 1.59-7.765 3.753-11.276 2.744-5.82-1.672-.916-5.81 1.955-7.185 5.857-2.803 12.15-4.785 18.586-6.352-2.011 4.415-4.474 8.307-9.265 10.793zm78.998-28.944c-15.372 2.089-30.722 4.36-45.99 7.114-4.398.793-8.851 1.559-13.3 2.404a333.907 333.907 0 0012.067-37.234c1.038-3.983-5.23-5.361-6.264-1.394-3.558 13.655-7.955 27.073-13.276 40.15-7.31 1.602-14.522 3.584-21.37 6.437-4.536 1.89-10.238 4.392-11.257 9.77-.947 4.996 2.952 9.533 7.714 10.667 5.765 1.373 12.443-1.376 17.337-4.266 5.732-3.386 8.533-8.45 11.072-14.377.398-.93.778-1.866 1.167-2.799 5.515-1.102 11.049-2.017 16.424-2.987 15.267-2.757 30.617-5.025 45.99-7.114 4.06-.552 3.784-6.928-.314-6.371zM91.65 32.156c-1.42 4.786-4.12 9.627-7.034 13.634-1.246 1.713-4.932 6.519-6.911 3.439-1.394-2.169.202-6.542 1.075-8.642 1.88-4.523 4.533-9.221 7.781-12.86 1.532-1.544 3.853-3.507 5.306-2.907 1.77.731.318 5.537-.216 7.336zM92.29 18c-3.683-.036-7.32 2.394-10.047 5.036-.096.087-.196.16-.288.263l-.124.142c-.407.411-.791.824-1.149 1.231a3.496 3.496 0 00-.459.67c-5.155 6.384-10.27 15.79-9.036 23.776.59 3.811 2.882 7.46 6.95 7.847 4.297.408 8.066-2.864 10.601-6.051 5.497-6.91 10.95-17.117 10.192-26.298-.308-3.731-2.803-6.578-6.64-6.616zM54.897 39.46c-1.441 4.75-4.18 9.555-7.137 13.532-1.264 1.7-5.005 6.47-7.013 3.413-1.413-2.152.206-6.493 1.091-8.577 1.908-4.489 4.6-9.152 7.896-12.762 1.554-1.534 3.91-3.482 5.382-2.887 1.796.726.323 5.496-.219 7.281zm-20.44 9.932a86.427 86.427 0 01-3.792.938c-1.977 9.49-8.557 22.105-19.366 22.44C-2.463 73.2-1.049 56.19 2.11 47.479 6.637 34.99 14.104 25.393 24.361 17.024c3.535-2.885 9.458-5.205 13.101-1.094 3.421 3.86.422 11.477-.97 15.587-1.308 3.864-7.594 2.506-6.272-1.398.677-2 1.27-4.01 1.703-6.077.4-1.904 1.37-4.286-1.396-3.47-3.04.896-6.304 5.018-8.544 7.171-5.772 5.549-9.677 11.849-12.793 19.181-1.89 4.449-6.881 23.371 4.288 18.92 5.372-2.142 8.632-8.484 10.264-14.255a86.445 86.445 0 01-4.123.484c-4.128.378-4.42-6.015-.313-6.39a76.235 76.235 0 0013.26-2.402c1.518-.416 2.75.208 3.472 1.2 1.798-4.328 4.525-8.467 7.263-11.784.123-.225.271-.448.465-.664.363-.404.753-.814 1.166-1.222.042-.046.084-.096.126-.14.093-.103.194-.176.292-.262 2.766-2.622 6.457-5.034 10.193-4.998 3.894.038 6.425 2.863 6.738 6.567.769 9.11-4.764 19.241-10.34 26.099-2.573 3.163-6.397 6.411-10.756 6.006-4.128-.383-6.455-4.005-7.052-7.789-.352-2.222-.196-4.555.324-6.902zM73.753 19.2l.139-.006c1.744-.085 3.34-1.693 3.171-3.483-.169-1.794-1.628-3.248-3.497-3.157l-.139.006c-1.744.085-3.34 1.693-3.172 3.482.17 1.795 1.628 3.25 3.498 3.158m46.706 8.91c-1.441 4.749-4.18 9.554-7.137 13.53-1.264 1.701-5.005 6.47-7.013 3.414-1.413-2.153.205-6.493 1.091-8.577 1.908-4.489 4.6-9.152 7.895-12.762 1.554-1.534 3.91-3.482 5.384-2.887 1.795.726.322 5.496-.22 7.281zm.646-14.05c-2.114-.02-4.213.749-6.14 1.89l4.248-11.285a3.236 3.236 0 00-1.906-4.172 3.26 3.26 0 00-4.19 1.897l-12.088 32.108a3.2 3.2 0 00-.135.51c-1.157 3.35-1.702 6.756-1.2 9.935.598 3.784 2.924 7.405 7.053 7.79 4.359.404 8.183-2.844 10.755-6.007 5.577-6.858 11.11-16.988 10.341-26.1-.313-3.704-2.844-6.528-6.738-6.566z",
    id: "GojobIcon_a_".concat(seedId)
  })), (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("mask", {
    id: "GojobIcon_b_".concat(seedId),
    fill: "#fff"
  }, (0, _core.jsx)("use", {
    xlinkHref: "#GojobIcon_a_".concat(seedId)
  }))), (0, _core.jsx)("g", {
    mask: "url(#GojobIcon_b_".concat(seedId, ")"),
    fill: "currentColor"
  }, (0, _core.jsx)("path", {
    d: "M0 0h128v92H0z"
  })));
};

__signature__(GojobLogo, "useLazyRef{}", function () {
  return [_useLazyRef["default"]];
});

var _default = (0, _react.forwardRef)(GojobLogo);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(GojobLogo, "GojobLogo", "/builds/bA1zbJom/0/gojob/ui-bits/src/GojobLogo/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/GojobLogo/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();